export default __webpack_public_path__ + "static/media/trash.34abd40a.svg";